export const createCart = /* GraphQL */ `
  mutation CreateCart($input: CreateCartInput!) {
    createCart(input: $input) {
      id
      createdAt
      updatedAt
      status
      storeID
      clientID
      client {
        firstname
        lastname
      }
      orderNumber
      delivery {
        type
        details
      }
      payment {
        type
        details
      }
      ticket
      items
      transactionID
    }
  }
`;

export const updateCart = /* GraphQL */ `
  mutation UpdateCart($input: UpdateCartInput!) {
    updateCart(input: $input) {
      id
      createdAt
      updatedAt
      status
      storeID
      clientID
      client {
        firstname
        lastname
      }
      orderNumber
      delivery {
        type
        details
      }
      payment {
        type
        details
      }
      ticket
      items
      transactionID
    }
  }
`;

export const createClient = /* GraphQL */ `
  mutation CreateClient($input: CreateClientInput!) {
    createClient(input: $input) {
      email
      firstname
      lastname
      phone
      address
      address2
    }
  }
`;

export const updateClient = /* GraphQL */ `
  mutation UpdateClient($input: UpdateClientInput!) {
    updateClient(input: $input) {
      email
      firstname
      lastname
      phone
      address
      address2
    }
  }
`;
